var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuperlikeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8_5477",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.444336,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8_5477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1038 15.7519L19.7403 12.6269L21.9614 12.8192L17.8883 16.3461L19.0922 21.6268L17.2057 20.4807L16.1038 15.7519ZM13.9749 9.15384L12.9634 6.78077L13.8153 4.72314L15.7595 9.32114L13.9749 9.15384ZM7.34997 18.2692L10.5 16.3692L13.65 18.2942L12.825 14.6942L15.6 12.2942L11.95 11.9692L10.5 8.56919L9.04997 11.9442L5.39997 12.2692L8.17497 14.6942L7.34997 18.2692ZM5.07502 21.4056L6.50769 15.2365L1.72119 11.0884L8.03654 10.5404L10.5 4.72314L12.9634 10.5404L19.2787 11.0884L14.4922 15.2365L15.9249 21.4056L10.5 18.1326L5.07502 21.4056Z",
    fill: "#4F4F4F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperlikeIcon);
export default __webpack_public_path__ + "static/media/superlike-icon.ef3a2ea2d20425eed7625b94652d2b12.svg";
export { ForwardRef as ReactComponent };